import { RequestInstance } from "../../../utils/request";

export const dataList = new RequestInstance({
  method: "get",
  url: "/v2/member/page",
});

export const addUser = new RequestInstance({
  method: "post",
  url: "/v2/member/add",
});

export const updateUserInfo = new RequestInstance({
  method: "post",
  url: "/v2/member/update",
});

export const removeUser = new RequestInstance({
  method: "post",
  url: "/v2/member/delete",
});

export const checkUserName = new RequestInstance({
  method: "get",
  url: "/v2/member/username/check",
});
